import { Button } from '@mui/material';
import { track, useDeclinePlaid } from '../../../../logic';
import { useLocation, useParams } from 'react-router-dom';
import { useOptimisticUpdateNotificationAndOrderNotification } from '../../../../logic/optimisticUpdates';
import { ErrorDialog } from '../../dialogs/ErrorDialog';

export function PlaidDeclineButton() {
  const { search } = useLocation()
  const { closingId, id } = useParams()

  const { optimisticUpdateNotificationAndOrderNotification } = useOptimisticUpdateNotificationAndOrderNotification()
  const declinePlaidMutation = useDeclinePlaid(closingId ?? '', id ?? '', search, {
    onSuccess: () => {
      optimisticUpdateNotificationAndOrderNotification({ orderKey: closingId ?? '', notificationId: id ?? '', search, patch: { IsComplete: true } });
    },
  })

  const onClick = () => {
    declinePlaidMutation.mutate(undefined)
  }

  //TODO: Either make this a common method or use some sort of global toast so that the toast could get populated inside of the onError in the useMutation
  if (declinePlaidMutation.isError) {
    track('error', 'declining plaid', {}, {
      message: JSON.stringify({
        declinePlaidMutation: declinePlaidMutation?.error, 
      }),
      component: 'AccountVerificationTask',
    })
    return <ErrorDialog error='There was an error processing your request.' tryAgainText='Reload and try again' />
  }

  return (
    <Button
      variant="text"
      color="primary"
      onClick={onClick}
      sx={{
        borderRadius: "40px",
        minWidth: "250px",
        color: "primary.main",
        mt: 1,
      }}
    >
      Decline Account Linking
    </Button>
  )
}

